import script from "./HeroPortal.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroPortal.vue?vue&type=script&setup=true&lang=js"

import "./HeroPortal.vue?vue&type=style&index=0&id=f4b78d52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4b78d52"]])

export default __exports__